
  export const environment = {
    production: true,
    intercomAppId: "c933130334ee21cb48ebc1fb42a106c244a1b99b",
    helpHeroAppId: "FUiraAba5mX",
    stripePublishableKey: "pk_live_msDGA0ftWZTWWj365ZToCRtg"
  };
